import { call, put, takeLatest, delay, select } from 'redux-saga/effects';
import { set, merge } from 'lodash';

import { cleanError, getTripError, getTripSuccess } from 'modules/common/CommonTrip/actions';
import { tripCommonTripSelector } from 'modules/common/CommonTrip/selectors';
import { peripheralsSelector } from 'modules/common/Header/selectors';
import { ResponseFaceID } from '../../../../../entities/Visitor/interfaces';
import { fieldFaceIdAdd } from './selectors';
import { BlackListService } from '../../../../../entities/BlackList/services';
import { VisitorService } from '../../../../../entities/Visitor/services';
import { Peripherals } from '../../../../../entities/Peripherals/interfaces';
import { Trip } from '../../../../../entities/Trip';
import { LocationDto, LocationService } from '../../../../../entities/Location';
import { ORDER_ADD_BLLIST_REQUEST, GET_LOCATION_REQUEST, ADD_USER_ID_REQUEST } from './constants';
import {
  addBLListReguest,
  addBLListSuccess,
  getLocationSuccess,
  getLocationError,
  addUserIDError,
  addUserIDSuccess,
  cleanErr,
  addUserIDReguest,
} from './actions';

function* addBlackLS(action: ReturnType<typeof addBLListReguest>) {
  try {
    // @ts-ignore
    yield call(BlackListService.postBlackList, action.payload);

    yield put(addBLListSuccess());
  } catch (error: any) {
    throw Error(error);
  }
}

function* getLocations() {
  const branchLocal = localStorage.getItem('branchId') || 'null';
  const branchId = JSON.parse(branchLocal)?.id;
  try {
    const locations: LocationDto[] = yield call(LocationService.getLocations, { params: { branchId } });

    yield put(getLocationSuccess(locations));
  } catch (error: any) {
    yield put(getLocationError(error));
  }
}

function* addDriverID(action: ReturnType<typeof addUserIDReguest>) {
  try {
    const valueTrip = action.value;
    const peripherals: Peripherals[] = yield select(peripheralsSelector);
    const url = peripherals?.find((p) => p.type === 'FaceID' && p.processName === 'Add User')?.peripheralUrl;

    if (!url) {
      yield put(addUserIDError(Error('Помилка підключення до пристрою FaceID!')));
      yield put(getTripError(Error('Помилка підключення до пристрою FaceID!')));

      yield delay(7000);
      yield put(cleanError());
      yield put(cleanErr());
      return;
    }

    const trip: Trip = yield select(tripCommonTripSelector);
    const response: ResponseFaceID = yield call(VisitorService.addFaceID, { url, id: action.payload });
    const fieldFaceId: string = yield select(fieldFaceIdAdd);
    const mergedTrip = merge(trip, valueTrip);
    if (response.success) {
      yield put(addUserIDSuccess());

      set(mergedTrip, `${fieldFaceId}.isFaceId`, true);

      yield put(getTripSuccess({ ...mergedTrip }));
      yield delay(7000);
      yield put(cleanErr());
    } else {
      yield put(addUserIDError(Error(response.description || 'Помилка')));
      yield put(getTripError(Error(response.description || 'Помилка підключення до пристрою FaceID!')));

      yield delay(7000);
      yield put(cleanError());
      yield put(cleanErr());
    }
  } catch (error: any) {
    yield put(addUserIDError(Error(error?.message || 'Помилка підключення до пристрою FaceID!')));
    yield put(getTripError(Error(error?.message || 'Помилка підключення до пристрою FaceID!')));

    yield delay(3000);
    yield put(cleanErr());
    yield put(cleanError());
  }
}

export function* tripOrderSagaWatcher() {
  yield takeLatest(GET_LOCATION_REQUEST, getLocations);
  yield takeLatest(ADD_USER_ID_REQUEST, addDriverID);
  yield takeLatest(ORDER_ADD_BLLIST_REQUEST, addBlackLS);
}
